import React from "react";
import styles from "../styles/Transform.module.css";
import { motion } from "framer-motion";

const Transform = () => {
  return (
    <motion.div
      className={styles.transform_cont_main}
      initial={{ opacity: 0, y: 50 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.2 }}
      transition={{ duration: 0.8, ease: "easeOut" }}
    >
      <div className={styles.transform_child}>
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.2 }}
        >
          Ready to Transform Your Business?
        </motion.h2>
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.4 }}
        >
          Let's discuss how Relico Ventures can help you achieve your strategic goals <br /> and unlock new opportunities.
        </motion.p>
        <motion.div
          style={{ display: "flex", justifyContent: "center", marginTop: "35px" }}
        >
          <a href="mailto:Rajesh.relan@relicoventures.com" target='_blank'>Get in Touch</a>
        </motion.div>
      </div>
    </motion.div>
  );
};

export default Transform;
